export const SET_OPERATION = 'SET_OPERATION';
export const SET_PAYBACK_INFO = 'SET_PAYBACK_INFO';
export const SET_SPLIT_PURCHASE_INFO = 'SET_SPLIT_PURCHASE_INFO';
export const SET_CONFIRM_MODAL_INFO = 'SET_CONFIRM_MODAL_INFO';
export const SET_MOVE_OPERATION_INFO = 'SET_MOVE_OPERATION_INFO';
export const SET_CLONE_OPERATION_INFO = 'SET_CLONE_OPERATION_INFO';
export const SET_CROPPER_INFO = 'SET_CROPPER_INFO';
export const SET_EVENT_SEARCH_VALUE = 'SET_EVENT_SEARCH_VALUE';
export const RESET_OPERATIONS_DATA = 'RESET_OPERATIONS_DATA';
export const MARK_OPERATION_SEEN = 'MARK_OPERATION_SEEN';
export const SET_OPERATION_IN_ONE_CLICK = 'SET_OPERATION_IN_ONE_CLICK';
